module.exports = __webpack_public_path__ + "static/media/vopr.63a0dd3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/vopr.png
// module id = 171
// module chunks = 0